import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	fetchedSkuTransactions: [],
};

const skuTransactionsSlice = createSlice({
	name: 'skuTransactions',
	initialState: initialState,
	reducers: {
		setSkuTransactions: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setSkuTransactions, reset } = skuTransactionsSlice.actions;

export default skuTransactionsSlice.reducer;